import { ApiClient } from "../ApiClient";

/**
 * Fetch general recommendations for the user
 * @returns {Promise<Response>} The raw fetch response
 */
export const getGeneralRecommendations = async () => {
  // ApiClient.get handles baseUrl, headers, and credentials automatically.
  // It returns the raw Response to maintain compatibility with calling components.
  return ApiClient.get("/recommendations/general-rec");
};

/**
 * Fetch service recommendations for the authenticated user
 */
export const getServiceRecommendations = async () => {
  const response = await ApiClient.get(
    "/recommendations/service-recommendations",
  );
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  return response.json();
};
